import { HttpResponse } from '@capacitor/core';

// True when the response declares a JSON mime type via its Content-Type header.
export const isJsonResponse = (response: HttpResponse): boolean => {
  const headers = response.headers ?? {};
  const contentTypeKey = Object.keys(headers).find(
    (key) => key.toLowerCase() === 'content-type'
  );

  if (!contentTypeKey) {
    return false;
  }

  return headers[contentTypeKey].toLowerCase().includes('json');
};
